import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import {
  ConsumerKpis,
  ConsumersState,
  ConsumerGrowthItem,
  ConsumerRecencyItem,
  ConsumerBreakdownItem,
  ConsumerLeaderboardData,
  CollectionDistributionData,
  ConsumerStrainDiversityItem,
} from "./types";

export const consumersInitialState: ConsumersState = {
  loadingKpis: false,
  loadingGrowth: false,
  loadingRecency: false,
  loadingBreakdown: false,
  loadingStrainDiversity: false,
  loadingLeaderboard: false,
  loadingCollectionDistribution: false,
  kpis: null,
  growth: null,
  recency: null,
  breakdown: null,
  strainDiversity: null,
  leaderboard: null,
  collectionDistribution: null,
  error: null,
};

const consumersSlice = createSlice({
  name: "analyticsConsumers",
  initialState: consumersInitialState,
  reducers: {
    setKpisLoading: (state, action: PayloadAction<boolean>) => {
      state.loadingKpis = action.payload;
    },
    setKpisSuccess: (state, action: PayloadAction<ConsumerKpis>) => {
      state.kpis = action.payload;
      state.loadingKpis = false;
      state.error = null;
    },
    setGrowthLoading: (state, action: PayloadAction<boolean>) => {
      state.loadingGrowth = action.payload;
    },
    setGrowthSuccess: (state, action: PayloadAction<ConsumerGrowthItem[]>) => {
      state.growth = action.payload;
      state.loadingGrowth = false;
      state.error = null;
    },
    setRecencyLoading: (state, action: PayloadAction<boolean>) => {
      state.loadingRecency = action.payload;
    },
    setRecencySuccess: (
      state,
      action: PayloadAction<ConsumerRecencyItem[]>,
    ) => {
      state.recency = action.payload;
      state.loadingRecency = false;
      state.error = null;
    },
    setBreakdownLoading: (state, action: PayloadAction<boolean>) => {
      state.loadingBreakdown = action.payload;
    },
    setBreakdownSuccess: (
      state,
      action: PayloadAction<ConsumerBreakdownItem[]>,
    ) => {
      state.breakdown = action.payload;
      state.loadingBreakdown = false;
      state.error = null;
    },
    setStrainDiversityLoading: (state, action: PayloadAction<boolean>) => {
      state.loadingStrainDiversity = action.payload;
    },
    setStrainDiversitySuccess: (
      state,
      action: PayloadAction<ConsumerStrainDiversityItem[]>,
    ) => {
      state.strainDiversity = action.payload;
      state.loadingStrainDiversity = false;
      state.error = null;
    },
    setLeaderboardLoading: (state, action: PayloadAction<boolean>) => {
      state.loadingLeaderboard = action.payload;
    },
    setLeaderboardSuccess: (
      state,
      action: PayloadAction<ConsumerLeaderboardData>,
    ) => {
      state.leaderboard = action.payload;
      state.loadingLeaderboard = false;
      state.error = null;
    },
    setCollectionDistributionLoading: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.loadingCollectionDistribution = action.payload;
    },
    setCollectionDistributionSuccess: (
      state,
      action: PayloadAction<CollectionDistributionData>,
    ) => {
      state.collectionDistribution = action.payload;
      state.loadingCollectionDistribution = false;
      state.error = null;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loadingKpis = false;
      state.loadingGrowth = false;
      state.loadingRecency = false;
      state.loadingBreakdown = false;
      state.loadingStrainDiversity = false;
      state.loadingLeaderboard = false;
      state.loadingCollectionDistribution = false;
    },
  },
});

export const {
  setError,
  setKpisLoading,
  setKpisSuccess,
  setGrowthLoading,
  setGrowthSuccess,
  setRecencyLoading,
  setRecencySuccess,
  setBreakdownLoading,
  setBreakdownSuccess,
  setLeaderboardLoading,
  setLeaderboardSuccess,
  setStrainDiversityLoading,
  setStrainDiversitySuccess,
  setCollectionDistributionLoading,
  setCollectionDistributionSuccess,
} = consumersSlice.actions;

export default consumersSlice.reducer;
